const encryptData = async (publicKey, data) => {
    try {
        // 公開鍵をインポート
        const importedKey = await window.crypto.subtle.importKey("spki", 
        // Base64形式の公開鍵をArrayBufferに変換
        base64ToArrayBuffer(publicKey), {
            name: "RSA-OAEP",
            hash: "SHA-256"
        }, false, ["encrypt"]);
        // データをエンコードして暗号化
        const encoder = new TextEncoder();
        const encodedData = encoder.encode(data);
        const encryptedData = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, importedKey, encodedData);
        // 暗号化されたデータをBase64に変換して返す
        return btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
    }
    catch (ex) {
    }
    return "";
};
/**
 * base64をArrayBufferに変換する
 */
const base64ToArrayBuffer = base64 => {
    const str = window.atob(base64);
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
};
export { encryptData };
